import type { WritebackPayload } from '../config/types';

export class WritebackApiError extends Error {
  constructor(
    message: string,
    public readonly statusCode?: number,
    public readonly responseBody?: string
  ) {
    super(message);
    this.name = 'WritebackApiError';
  }
}

export async function submitWritebackToApi(
  apiUrl: string,
  payload: WritebackPayload
): Promise<void> {
  let response: Response;
  try {
    response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    throw new WritebackApiError(
      `Network error connecting to writeback API: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
  }

  if (!response.ok) {
    const responseBody = await response.text().catch(() => '');
    throw new WritebackApiError(
      `Writeback API error: ${response.status} ${response.statusText}${responseBody ? ` - ${responseBody}` : ''}`,
      response.status,
      responseBody
    );
  }
}
